import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    'attendanceEnabledInfo',
    'attendanceDisabledInfo',
    'trackAttendanceInput',
    'attendanceWarning',
    'checkbox'
  ];

  connect() {
    this.boundSync = this.sync.bind(this);
    document.addEventListener('promote:attendance-tracking-toggle', this.boundSync);
  }

  disconnect() {
    document.removeEventListener('promote:attendance-tracking-toggle', this.boundSync);
  }

  toggleAttendanceTracking() {
    const checked = this.checkboxTarget.checked;

    this.applyState(checked);

    // Keep the toggle of the other session type (online/classroom) in sync, so the
    // value stays the same whichever type the user ends up selecting.
    document.dispatchEvent(
      new CustomEvent('promote:attendance-tracking-toggle', { detail: { checked } })
    );
  }

  sync(event) {
    const { checked } = event.detail;

    if (this.checkboxTarget.checked === checked) return;

    this.checkboxTarget.checked = checked;
    this.applyState(checked);
  }

  applyState(checked) {
    if (this.hasTrackAttendanceInputTarget) {
      this.trackAttendanceInputTarget.value = checked ? '1' : '0';
    }

    this.attendanceEnabledInfoTarget.classList.toggle('hidden', !checked);
    this.attendanceDisabledInfoTarget.classList.toggle('hidden', checked);

    if (this.hasAttendanceWarningTarget) {
      this.attendanceWarningTarget.classList.toggle('hidden', checked);
    }
  }
}
